import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { toast } from "sonner";
import axios from "axios";
import { Lock, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_3e64acab-2561-42e6-b860-06b1a563df4d/artifacts/5nvw3yv2_6ECA6BBA-F429-4238-A743-EE6BF2D1D33F.png";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      toast.error("Please fill in all fields");
      return;
    }
    
    setLoading(true);
    try {
      const response = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("admin_token", response.data.access_token);
      axios.defaults.headers.common["Authorization"] = `Bearer ${response.data.access_token}`;
      toast.success("Welcome, Admin!");
      navigate("/admin/dashboard");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <div className="flex items-center justify-center gap-3 mb-8">
          <img src={LOGO_URL} alt="Coach Coop" className="h-12 w-12 rounded-sm" />
          <span className="font-black text-2xl tracking-tighter">ADMIN PORTAL</span>
        </div>
        
        <Card className="bg-card border-border">
          <CardHeader>
            <CardTitle className="text-xl font-black uppercase tracking-tighter text-center flex items-center justify-center gap-2">
              <Lock className="h-5 w-5 text-primary" />
              Admin Login
            </CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="email" className="uppercase text-sm tracking-wider">Email</Label>
                <Input
                  id="email"
                  type="email"
                  data-testid="admin-email-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="temperedhead@gmail.com"
                  className="bg-input border-transparent focus:border-primary rounded-sm"
                />
              </div>
              
              <div className="space-y-2">
                <Label htmlFor="password" className="uppercase text-sm tracking-wider">Password</Label>
                <Input
                  id="password"
                  type="password"
                  data-testid="admin-password-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter admin password"
                  className="bg-input border-transparent focus:border-primary rounded-sm"
                />
              </div>
              
              <Button
                type="submit"
                data-testid="admin-login-btn"
                disabled={loading}
                className="w-full bg-primary hover:bg-primary/90 uppercase font-bold tracking-widest rounded-sm"
              >
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Access Dashboard"}
              </Button>
            </form>
          </CardContent>
        </Card>
        
        <p className="text-center text-xs text-muted-foreground mt-4">
          Credentials: temperedhead@gmail.com / admin123
        </p>
      </motion.div>
    </div>
  );
}
